
export class SettingsSubscription {
	/* MARK: Component life cycle
	   =================================
	*/
	constructor(){}
	/* MARK: Custom methods
	   =================================
	*/
	backNavi(){ if(history.length != 0){history.back();}}
}
